import Core from "@/modules/core/service/Core";

const url = {
    outbox: "/api/incident/mail/outbox"
}

export default {
    findOutboxEntries (customerIds, from, to, typeId, onlyMyEmails) {
        return Core.method.post(url.outbox, {
            customerIds : customerIds,
            from        : from,
            to          : to,
            typeId      : typeId,
            onlyMyEmails: onlyMyEmails
        });
    }
}